import React, { useEffect, useRef } from 'react'

import './VideoSection.styles.scss'
import { Section } from '@components/Section'

export const VideoSection = () => {
  const videoFrameRef = useRef<HTMLIFrameElement>()

  useEffect(() => {
    const loadVimeoPlayer = async () => {
      const { default: VimeoPlayer } = await import('@vimeo/player')
      const player = new VimeoPlayer(videoFrameRef.current)

      const observer = new IntersectionObserver((entries) => {
        const [ video ] = entries

        if(video.isIntersecting) {
          player.play()
        } else {
          player.pause()
        }
      }, {
        threshold: .3
      })

      observer.observe(videoFrameRef.current)
    }

    loadVimeoPlayer()
  }, [])

  return (
    <Section className='VideoSection' id='about'>
      <iframe
        src="https://player.vimeo.com/video/774332983?color=2B30F5&muted=1&loop=1"
        ref={videoFrameRef}
        frameBorder="0"
        allow='autoplay; fullscreen; picture-in-picture'
        allowFullScreen
      />
    </Section>
  )
}
